import { storage } from '@/lib/storage';
import { useCallback, useState } from 'react';

// hooks/useTenantSlug.ts
export const useTenantSlug = () => {
  const [tenantSlug, setTenantSlug] = useState(() => {
    // // Initialize state with localStorage value or extract from URL
    const savedSlug = storage.get('tenantSlug');
    return savedSlug || '';
  });

  const saveTenantSlug = useCallback((slug: string) => {
    storage.set('tenantSlug', slug);
    setTenantSlug(slug);
  }, []);

  const clearTenantSlug = useCallback(() => {
    storage.remove('tenantSlug');
    setTenantSlug('');
  }, []);

  return {
    tenantSlug,
    saveTenantSlug,
    clearTenantSlug,
    hasSavedTenantSlug: Boolean(tenantSlug),
  };
};
